import React from 'react'
import { PropTypes } from 'prop-types'
import { RESOURCEdb } from '@wellbeingxltd/fe-lib/constants'
import { Community, Exercise, Meaningful, Nutrition, Sleep, Stress } from '@wellbeingxltd/fe-lib/images/dist/pillars/icons/web/index'
import CommunityIl from '@wellbeingxltd/fe-lib/images/dist/pillars/illustrations/Community.svg'
import ExerciseIl from '@wellbeingxltd/fe-lib/images/dist/pillars/illustrations/Exercise.svg'
import IntroIl from '@wellbeingxltd/fe-lib/images/dist/illustrations/Waving_Hand.png'
import MeaningfulIl from '@wellbeingxltd/fe-lib/images/dist/pillars/illustrations/Meaningful.svg'
import NutritionIl from '@wellbeingxltd/fe-lib/images/dist/pillars/illustrations/Nutrition.svg'
import SleepIl from '@wellbeingxltd/fe-lib/images/dist/pillars/illustrations/Sleep.svg'
import StressIl from '@wellbeingxltd/fe-lib/images/dist/pillars/illustrations/Stress.svg'
import Financial from 'assets/images/Financial.svg'
import FinancialIl from 'assets/images/FinancialIl.svg'

const {
    PILLARS: { COMMUNITY, EXERCISE, OCCUPATION, NUTRITION, SLEEP, STRESS, FINANCIAL },
} = RESOURCEdb

const LogoChooser = ({ decorative = false, label, width, height }) => {
    const logoChoose = () => {
        let result
        switch (label.replace(/ /g, '')) {
            case COMMUNITY:
                result = <Community decorative={decorative} width={width} />
                break
            case EXERCISE:
                result = <Exercise decorative={decorative} width={width} />
                break
            case OCCUPATION:
                result = <Meaningful decorative={decorative} width={width} />
                break
            case SLEEP:
                result = <Sleep decorative={decorative} width={width} />
                break
            case NUTRITION:
                result = <Nutrition decorative={decorative} width={width} />
                break
            case STRESS:
                result = <Stress decorative={decorative} width={width} />
                break
            case FINANCIAL:
                result = <img src={Financial} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `${COMMUNITY}Illustration`:
                result = <img src={CommunityIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `${EXERCISE}Illustration`:
                result = <img src={ExerciseIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `${OCCUPATION}Illustration`:
                result = <img src={MeaningfulIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `HelloIllustration`:
                result = <img src={IntroIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `${SLEEP}Illustration`:
                result = <img src={SleepIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `${NUTRITION}Illustration`:
                result = <img src={NutritionIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `${STRESS}Illustration`:
                result = <img src={StressIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            case `${FINANCIAL}Illustration`:
                result = <img src={FinancialIl} alt="" aria-hidden="true" {...{ height, width }} />
                break
            default:
                result = ''
                break
        }
        return result
    }

    return logoChoose(label)
}

LogoChooser.propTypes = {
    label: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
}

export default LogoChooser
